export default __webpack_public_path__ + "static/media/3.ed05a7f2.jpg";